<script type="text/ecmascript-6">
    import Layout from '../layouts/MainLayout.vue'
    import Modal from '../components/modal';
    import { mapGetters  } from 'vuex';
    import TopHeader from "../components/TopHeader";
    import DateRange from "../components/DateRange";

    export default {
        components: {DateRange, Layout, Modal, TopHeader },

        /**
         * The component's data.
         */
        data: () => ({
            spend_amount: 0,
            spent_out: 0,
            post_id: null,

            showModal: false,

            dateRange: {
                startDate: '2019-12-10',
                endDate: '2019-12-20',
            },
        }),

        /**
         * Computed these properties.
         */
        computed: {
            ...mapGetters({
                isLoading: 'getIsLoading',
                isShow: 'getIsShow',
                dateTime: 'getDateTime',
                ownPageData: 'getOwnPageData',
                isPreview: 'getIsPreview',
                isPrint: 'getIsPrint',
            })
        },

        methods: {
            formSubmit() {
                this.$store.dispatch('setPostSpend',{post_id: this.post_id, spend_amount: this.spend_amount, spent_out: this.spent_out});
                this.showModal = false;
            },

            clickModal(post) {
                this.showModal = true;
                this.post_id = post.id;
                this.spend_amount = post.spend_amount;
                this.spent_out = post.spent_out;
            }
        }
    }
</script>

<template>
    <layout>

        <div :class="{'container-fluid' : !isPreview }" v-show="!isLoading">
            <date-range></date-range>
            <div class="card" :class="[{'mb-3': !isPreview}, {'border-0': isPreview}]" v-show="isShow">
                <div class="card-body">

                    <TopHeader name="Media Spend Report"></TopHeader>

                    <div class="row mt-5 mb-2">
                        <div class="col-md-12 text-black">
                            <table class="table">
                                <tbody>
                                <tr class="border-top" v-for="post in ownPageData.posts" v-bind:key="post.id">
                                    <td>
                                        <img :src="post.picture" width="50" alt=""/>
                                    </td>
                                    <td>
                                        <h4 class="text-black">Post engagements</h4>
                                        <p class="text-black mb-0">{{ post.message.substring(0,100) }}...</p>
                                        <p class="text-black mb-0">Promoted by Mocha - Social Media Agency on {{ moment(post.date).format('MMM D YYYY')}}</p>
                                        <p class="text-black mb-0">Completed</p>
                                    </td>
                                    <td>
                                        <h2 class="font-weight-bolder">{{ numberFormat(post.engagement) }}</h2>
                                        <p>Post Engagement</p>
                                    </td>
                                    <td>
                                        <h2 class="font-weight-bolder">{{ numberFormat(post.reach) }}</h2>
                                        <p>People Reached</p>
                                    </td>
                                    <td v-on:click.prevent="clickModal(post)">
                                        <h2 class="font-weight-bolder">${{ numberFormat(post.spend_amount) }}</h2>
                                        <p>Spent out of ${{ numberFormat(post.spent_out) }}</p>
                                    </td>
                                </tr>
                                <tr class="border-top">
                                    <td colspan="2">
                                        <h2 class="font-weight-bolder text-center">TOTAL</h2>
                                    </td>
                                    <td>
                                        <h2 class="font-weight-bolder">{{ numberFormat(sum(ownPageData.posts, 'engagement')) }}</h2>
                                        <p>Post Engagement</p>
                                    </td>
                                    <td>
                                        <h2 class="font-weight-bolder">{{ numberFormat(sum(ownPageData.posts, 'reach')) }}</h2>
                                        <p>People Reached</p>
                                    </td>
                                    <td>
                                        <h2 class="font-weight-bolder">${{ numberFormat(sum(ownPageData.posts, 'spend_amount')) }}</h2>
                                        <p>Spent out of ${{ numberFormat(sum(ownPageData.posts, 'spent_out')) }}</p>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <modal v-if="showModal" @close="showModal = false">
            <form action="/" @submit.prevent="formSubmit" slot="body">
                <div class="form-group">
                    <label for="spend_amount">Spend Amount</label>
                    <input class="form-control" type="text" id="spend_amount" name="spend_amount" v-model="spend_amount">
                </div>
                <div class="form-group">
                    <label for="spent_out">Spent Out</label>
                    <input class="form-control" type="text" id="spent_out" name="spent_out" v-model="spent_out">
                </div>
                <button type="submit" class="btn btn-success float-right">Save</button>
            </form>
        </modal>

    </layout>
</template>
